<template>
    <!--分享-->
    <transition name="actionsheet-float">
      <div v-if="currentValue" class="mint-actionsheet" style="z-index: 2001">
        <ul class="mint-actionsheet-list" style="margin-bottom: 5px">
          <li class="mint-actionsheet-listitem sharetime">
            <div class="shareTip">文件分享有效期</div>
            <ul class="clearfix period">
              <li class="fl"><em class="aging" @click="time=1" :class="{'checked': time===1}"></em>1天过期</li>
              <li class="fl"><em class="aging" @click="time=7" :class="{'checked': time===7}"></em>7天过期</li>
              <li class="fl"><em class="aging" @click="time=0" :class="{'checked': time===0}"></em>永久有效</li>
            </ul>
          </li>
          <li class="mint-actionsheet-listitem">
            <span @click="sendWorkmate">发给同事</span>
          </li>
          <li class="mint-actionsheet-listitem" v-if="!isGenerateLink">
            <span @click="shareBegin">链接分享</span>
          </li>
          <li class="mint-actionsheet-listitem" v-else>
            <!--<span @click="shareBegin">分享</span>-->
            <span id="clipboard" @click="clip">复制链接</span>
          </li>
          <input type="text" class="clipboard" value="1" v-show="false">
        </ul>
        <a class="mint-actionsheet-button" @click.stop="$emit('share', false);currentValue = false;time=false;clipFlag=true">取消</a>
        <choose-member v-if="isSendWorkmate" eleTitle="选择同事" :cancelOperation="cancelSendWorkmate" :confirmOperation="confirmSendWorkmate"></choose-member>
      </div>
    </transition>
</template>

<script>
  import apis from '../apis/index'
  import {MessageBox, Toast, Indicator, Popup} from 'mint-ui'
  import cloudApi from '../apis/cloudStorageApi'
  import Clipboard from 'clipboard'
  import chooseMember from './addmember'

  export  default {
    components: {
      chooseMember
    },
    name: 'share',
    data () {
      return {
        isGenerateLink: false,
        time: 0,
        clipFlag: true,
        currentValue: true,
        isCopy: false,
        isSendWorkmate: false
      }
    },
    props: ['fileId'],
    created () {
    },
    methods: {
      //      分享
      shareBegin: function () {
        let _this = this
        apis.request(cloudApi.share, {fileIds: _this.fileId, shareType: 0, validTime: _this.time}).then(function (res) {
          _this.isGenerateLink = true
          _this.clipFlag = false
          let shareLink = window.location.protocol + '//' + window.location.host + res.data.shareLink
          /* eslint-disable */
          if (_this.clipFlag === false) {
            new Clipboard('#clipboard', {
              text: function () {
                return shareLink
              }
            })
          }
        }).catch(function (error) {
          console.log(11111111111)
          Toast({
            message: error.response.data.message,
            iconClass: 'icon-error'
          })
        })
      },
//      复制链接
      clip: function () {
        let _this = this
          this.$emit('share', true)
          Toast({
            message: '链接已复制',
            iconClass: 'icon-success'
          })
        this.isGenerateLink = false
      },
      sendWorkmate () {
        this.isSendWorkmate = true
      },
      cancelSendWorkmate () {
        this.isSendWorkmate = false
      },
      confirmSendWorkmate (userIds) {
        let _this = this
        this.isSendWorkmate = false
        apis.request(cloudApi.shareWorkmate, {fileIds: this.fileId, receiveUserIds: userIds.join(','), validTime: this.time}).then(() => {
          Toast({
            message: '分享成功',
            iconClass: 'icon-success'
          })
          _this.$emit('share', false)
        })
      }
    }
  }
</script>

<style scoped>
  /*分享样式*/
  .mint-actionsheet,.max-actionsheet {
    position: fixed;
    background: #e0e0e0;
    width: 100%;
    text-align: center;
    bottom: 0;
    left: 50%;
    transform: translate3d(-50%, 0, 0);
    backface-visibility: hidden;
    transition: transform .3s ease-out;
  }

  .mint-actionsheet-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .mint-actionsheet-listitem {
    border-bottom: solid 1px #e0e0e0;
  }

  .mint-actionsheet-listitem span {
    width: 49%;
    height: 100%;
    display: inline-block;
  }

  /*.mint-actionsheet-listitem span:first-of-type {
    border-right: 1px solid #e0e0e0;
  }*/

  .mint-actionsheet-button {
    display: block;
    width: 100%;
    height: 45px;
    line-height: 45px;
    font-size: 18px;
    color: #333;
    background-color: #fff;
  }

  .mint-actionsheet-button:active {
    background-color: #f0f0f0;
  }
  .actionsheet-float-enter,
  .actionsheet-float-leave-active {
    transform: translate3d(-50%, 100%, 0);
  }

  .sharetime {
    height: 1.46rem !important;
    font-size: 0.3rem !important;
  }

  .shareTip {
    height: 0.65rem !important;
    font-size: 0.3rem !important;
    color: #888 !important;
    text-align: left;
    line-height: 0.65rem;
    padding-left: 0.3rem;
    padding-top: 0.1rem;
  }

  .isClip {
    opacity: 0.1;
  }

  .period {
    height: 0.81rem !important;
    line-height: 0.81rem;
  }

  .period .aging {
    width: 0.24rem;
    height: 0.24rem;
    border: 1px solid #979797;
    display: inline-block;
    border-radius: 50%;
    margin-right: 5px;
  }

  .period .checked {
    background: url('../assets/images/success_big.png') center no-repeat;
    background-size: 0.24rem 0.24rem;
    border: none;
  }

  .period li {
    width: 33.333%;
    height: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/share.vue